/* eslint-disable-next-line */
import { event, utils } from '../../../Foundation';

class ProductSelector {
  /**4
   * @description Initialization of product selector
   * @param {Object} args - Arguments
   */
  constructor(args) {
    this._refs = {
      el: args.el,
      target: args.el.querySelector('#configurator__section--main-model__placeholder'),
      productGUID: document.getElementById('SelectedProduct'),
      productColor: document.getElementById('SelectedColorItemIdHiddenField'),
      pimSettings: {
        url: `${window.location.origin}/api/pim/getColorImageAssets`,
        filetype: 'psd',
        isHCPConnectTemplate: utils.checkIfNewBTE(),
      },
    };

    this._props = {
      translations: JSON.parse(this._refs.el.dataset.translations),
      products: JSON.parse(this._refs.el.dataset.models),
      selectedProductGuid: this._refs.productGUID.value,
    };

    // State
    this._store = {
      filters: {
        family: document.querySelector('#configurator__family').value,
        techLevel: document.querySelector('#configurator__technology').value,
        shellType: document.querySelector('#configurator__shelltype').value,
      },
    };

    this._initBuildTemplate();
    this._addPIMImageToModal();

    // # Set selection
    this.setRelatedProductsVisible();

    // Bind events
    Array.from(this._refs.el.querySelectorAll('input[type="radio"]')).forEach((option) =>
      option.addEventListener('change', this._onFilterItemChange.bind(this)),
    );

    // Bind Key events
    Array.from(this._refs.el.querySelectorAll('input[type="radio"]')).forEach((option) =>
      option.addEventListener('keydown', this._onKeyDown.bind(this)),
    );
  }

  _initBuildTemplate() {
    // PIM image only used in HCP connect template
    // # Inject required markup
    this.buildAndInjectTemplates();
    if (this._refs.pimSettings.isHCPConnectTemplate) {
      // Fetch image from PIM
      this._fetchPimImage(
        this.getSelectedProductById,
        this._refs.productColor?.value,
        this._setProductImage.bind(this),
      );
    }
  }

  _setProductImage(data) {
    const addProductImage = () => {
      imageElem.src = productImage;
    };
    const removeLoadingAnimation = () => {
      this._refs.el.querySelector('.loading_animation').remove();
      imageElem.classList.remove('is-hidden');
    };
    const imageElem = this._refs.el.querySelector('.product_image');
    const productImage = this._getProductImage(this.getSelectedProductById, data);
    if (!imageElem) return;
    addProductImage();
    removeLoadingAnimation();
  }

  /**
   * Handler for manipulating options and filtering when user selects an option
   * @param {Event} e - Event interface
   */
  _onFilterItemChange(e) {
    const target = e.target || e,
      isDisabled = !target.dataset.available;

    // If user clicks on an invalid selection, reset everything
    if (isDisabled) {
      Array.from(this._refs.el.querySelectorAll('input[type="radio"]')).forEach((option) => {
        if (option.id !== target.getAttribute('id')) {
          option.checked = false;
        }
      });
    }

    // Update store with current criterias
    this.updateStore();

    // // Set visible items based on selection
    this.setRelatedProductsVisible(e);

    const arrFamilyInputs = Array.from(
        this._refs.el.querySelectorAll('input[type="radio"][name="family"]'),
      ).filter((x) => x.dataset.available),
      arrTechLevelInputs = Array.from(
        this._refs.el.querySelectorAll('input[type="radio"][name="techLevel"]'),
      ).filter((x) => x.dataset.available),
      arrShellTypeInputs = Array.from(
        this._refs.el.querySelectorAll('input[type="radio"][name="shellType"]'),
      ).filter((x) => x.dataset.available);

    let boolRefresh = false;
    if (arrFamilyInputs.length === 1) {
      arrFamilyInputs[0].checked = true;
      boolRefresh = true;
    }

    if (arrTechLevelInputs.length === 1) {
      arrTechLevelInputs[0].checked = true;
      boolRefresh = true;
    }

    if (arrShellTypeInputs.length === 1) {
      arrShellTypeInputs[0].checked = true;
      boolRefresh = true;
    }

    // Refire
    if (boolRefresh) {
      this.updateStore();
      this.setRelatedProductsVisible(e);
    }

    const oModel = this.getSelectedProductByModel;

    if (Object.keys(oModel).length) {
      const oImage = this._refs.el.querySelector(
        '.configurator__section__fields__subsection--main-model__control--image-wrapper > img',
      );
      if (oImage != null) {
        oImage.setAttribute('src', oModel.imageUrl);
        oImage.setAttribute('alt', oModel.id);
      }

      this._refs.productGUID.value = oModel.id;
      this._doPostBackWithValidation('OverviewUpdatePanel', '');
    }
  }

  /**
   * Handler for key event to select / switch between select option
   * @param {Event} e - Event interface
   */
  _onKeyDown(e = Event) {
    const keyCode = e.keyCode,
      arrOptions = Array.from(
        document.querySelectorAll(
          '.configurator__section__fields__subsection--main-model__control',
        ),
      );

    // Key event up and down arrow
    if (keyCode === 38 || keyCode === 40) {
      e.preventDefault();
      e.stopPropagation();

      utils
        .getNextActiveElement(
          arrOptions,
          e.target.parentNode,
          e.keyCode === 40,
          !arrOptions.includes(e.target),
        )
        .children[1].focus();
    }

    // Key event left and right arrow
    if (keyCode === 37 || keyCode === 39) {
      e.preventDefault();
      e.stopPropagation();
    }
  }

  /**
   * @description Test, update and set options according to filtering requirements
   */
  /* eslint-disable-next-line */
  setRelatedProductsVisible(e) {
    const oModels = this._props.products,
      arrFamilyInputs = Array.from(
        this._refs.el.querySelectorAll('input[type="radio"][name="family"]'),
      ),
      arrTechLevelInputs = Array.from(
        this._refs.el.querySelectorAll('input[type="radio"][name="techLevel"]'),
      ),
      arrShellTypeInputs = Array.from(
        this._refs.el.querySelectorAll('input[type="radio"][name="shellType"]'),
      ),
      arrActiveKeys = Object.keys(this._store.filters).filter((x) => this._store.filters[x] !== ''),
      isOnlyCategory = (key) => arrActiveKeys.length === 1 && arrActiveKeys.includes(key);

    // Family
    const oFamilyProperties = this._getDistinctProperties(
      oModels.filter((x) => {
        if (arrActiveKeys.includes('techLevel') && arrActiveKeys.includes('shellType')) {
          return (
            x.techLevel === this._store.filters.techLevel &&
            x.shellType === this._store.filters.shellType
          );
        }

        if (arrActiveKeys.includes('shellType')) {
          return x.shellType === this._store.filters.shellType;
        }

        if (arrActiveKeys.includes('techLevel')) {
          return x.techLevel === this._store.filters.techLevel;
        }

        return x.family === this._store.filters.family;
      }),
      'family',
    );

    arrFamilyInputs.forEach((x) => {
      x.removeAttribute('data-available');
      if (oFamilyProperties.includes(x.value) || isOnlyCategory('family')) {
        x.setAttribute('data-available', true);
      }
    });

    // Techlevel
    const oTechLevelProperties = this._getDistinctProperties(
      oModels.filter((x) => {
        if (arrActiveKeys.includes('family') && arrActiveKeys.includes('shellType')) {
          return (
            x.family === this._store.filters.family && x.shellType === this._store.filters.shellType
          );
        }

        if (arrActiveKeys.includes('family')) {
          return x.family === this._store.filters.family;
        }

        if (arrActiveKeys.includes('shellType')) {
          return x.shellType === this._store.filters.shellType;
        }

        return x.techLevel === this._store.filters.techLevel;
      }),
      'techLevel',
    );

    arrTechLevelInputs.forEach((x) => {
      x.removeAttribute('data-available');
      if (oTechLevelProperties.includes(x.value) || isOnlyCategory('techLevel')) {
        x.setAttribute('data-available', true);
      }
    });

    // Shelltype
    const oShellTypeProperties = this._getDistinctProperties(
      oModels.filter((x) => {
        if (arrActiveKeys.includes('family') && arrActiveKeys.includes('techLevel')) {
          return (
            x.family === this._store.filters.family && x.techLevel === this._store.filters.techLevel
          );
        }

        if (arrActiveKeys.includes('family')) {
          return x.family === this._store.filters.family;
        }

        if (arrActiveKeys.includes('techLevel')) {
          return x.techLevel === this._store.filters.techLevel;
        }

        return x.shellType === this._store.filters.shellType;
      }),
      'shellType',
    );

    arrShellTypeInputs.forEach((x) => {
      x.removeAttribute('data-available');
      if (oShellTypeProperties.includes(x.value) || isOnlyCategory('shellType')) {
        x.setAttribute('data-available', true);
      }
    });
  }

  /**
   * @description Update store with current selected filters and clean it afterwards to ensure only selected values are stored correctly
   */
  updateStore() {
    this._store.filters = {
      family:
        this._refs.el.querySelector(
          '.configurator__section__fields__subsection--family input[type="radio"]:checked',
        ) !== null
          ? this._refs.el.querySelector(
              '.configurator__section__fields__subsection--family input[type="radio"]:checked',
            ).value
          : '',
      techLevel:
        this._refs.el.querySelector(
          '.configurator__section__fields__subsection--techLevel input[type="radio"]:checked',
        ) !== null
          ? this._refs.el.querySelector(
              '.configurator__section__fields__subsection--techLevel input[type="radio"]:checked',
            ).value
          : '',
      shellType:
        this._refs.el.querySelector(
          '.configurator__section__fields__subsection--shellType input[type="radio"]:checked',
        ) !== null
          ? this._refs.el.querySelector(
              '.configurator__section__fields__subsection--shellType input[type="radio"]:checked',
            ).value
          : '',
    };
  }

  /**
   * @description Update store by key, value reference
   */
  updateStoreByKey(index = String, key = String, value) {
    const item = this._store[index];
    if (item != 'undefined') {
      item[key] = value;
    }
  }

  /**
   * @description Get a product model based on GUID
   * @returns {Object} - Product model
   */
  get getSelectedProductById() {
    return (
      this._props.products.filter((x) => x.id === this._props.selectedProductGuid)[0] ||
      this._props.products.filter((x) => x.modelNumber.includes(SelectedProductModel.value))[0]
    );
  }

  /**
   * @description Get a model based upon current filters, if more than one result, sort by sortOrder and return only the highest priority
   * @returns {Object} Product model
   */
  get getSelectedProductByModel() {
    let model = this._props.products.filter(
        (x) =>
          x.family === this._store.filters.family &&
          x.techLevel === this._store.filters.techLevel &&
          x.shellType === this._store.filters.shellType,
      ),
      response = model[0];

    if (model.length > 1) {
      response = model.sort((a, b) => b.sortOrder - a.sortOrder)[0];
    }

    return response || {};
  }

  /**
   * @description Build & render image and options for topcontrol
   */
  buildAndInjectTemplates() {
    let oHtml = '';
    let oCategories = this._getDistinctProperties();
    const productDescription = this._getProductDescription(this.getSelectedProductById);

    // Genereate image
    oHtml += this._imageTemplate(productDescription);
    oHtml += this._optionTemplate(this._props.translations['family'], oCategories.family, 'family');
    oHtml += this._optionTemplate(
      this._props.translations['technology'],
      oCategories.techLevel,
      'techLevel',
    );
    oHtml += this._optionTemplate(
      this._props.translations['shelltype'],
      oCategories.shellType,
      'shellType',
    );

    this._refs.target.innerHTML = oHtml;
  }

  /**
   * @description Generate an imagetemplate containing image for current product
   * @returns {String} Template literal
   */
  _imageTemplate(productDescription) {
    // Default template (NO PIM)
    let imageTemplate = `<img src="${this.getSelectedProductById.imageUrl}" class="product_image" alt="${productDescription}" title="${productDescription}" />`;
    // HCP Connect template (PIM)
    if (this._refs.pimSettings.isHCPConnectTemplate) {
      imageTemplate = `
            <div class="loading_animation">
                <div class="progress_animation" role="alert" aria-busy="true" aria-live="polite">
                    <i class="eva eva-loader-outline" aria-hidden="true"></i>
                </div>
            </div>
            <img src="" class="product_image is-hidden" alt="${productDescription}" title="${productDescription}" />
            `;
    }

    return `<section class="configurator__section__fields__subsection configurator__section__fields__subsection--main-model configurator__section__fields__subsection--image">
            <div class="configurator__section__fields__subsection--main-model__control--image">
                <div class="configurator__section__fields__subsection--main-model__control--image-wrapper">
                    ${imageTemplate}
                </div>
            </div>
        </section>`;
  }

  _getProductDescription(meta) {
    return meta ? meta.description.replace(/(<([^>]+)>)/gi, '') : '';
  }

  _fetchPimImage(meta, color, cb) {
    try {
      if (!color) {
        return cb({});
      }
      fetch(
        `${this._refs.pimSettings.url}/${meta.modelNumber}?filetype=${this._refs.pimSettings.filetype}&color=${color}&primary=true`,
      )
        .then((response) =>
          response.json().then((data) => ({ status: response.status, payload: data, color })),
        )
        .then((data) => cb(data))
        .catch((err) => cb({ err }));
    } catch (err) {
      return cb({ status: 500, payload: err });
    }
  }

  _getProductImage(meta, pimData) {
    const defaultImage = meta ? meta.imageUrl : '';
    // Check if pim data includes image
    if (pimData?.status !== 200) return defaultImage;
    const primaryImage =
      pimData.payload[0]?.ThumbnailUrls['thumbnail550'] || pimData.payload[0]?.Path;
    // Get first product image from pim
    return primaryImage || defaultImage;
  }

  /**
   * Helper for generating a valid id for an option
   * @param {String} value - Value to transform
   * @returns {String} Formatted id-value
   */
  _formatId(value) {
    if (value) {
      let output = value.replace(/\W+/g, '');
      if (output != '') {
        return output;
      }
      for (let i = 0, len = value.length; i < len; i++) {
        output += value[i].charCodeAt(0);
      }
      return output;
    }
  }

  /**
   * Generate options based on data-configuration
   * @type Template
   * @param {String} title - Headline of colleciton
   * @param {Object} data - Collection of unique data properties
   * @param {String} key - Key identifier, primarely used for frontend purpose
   * @returns {String} - Template literal
   */
  _optionTemplate(title, data, key) {
    if (typeof data !== 'object' || !Object.keys(data).length) return '';

    const items = data
      .map((i) => {
        const id = key + '-' + this._formatId(i),
          checked = i === this._store.filters[key];

        return `<div class="configurator__section__fields__subsection--main-model__control">
                <input type="radio" name="${key}" id="${id}" class="configurator__section__fields__subsection--main-model__input sr-only" value="${i}" ${
          checked ? 'checked="true"' : ''
        }/>
                <label for="${id}" class="configurator__section__fields__subsection--main-model__label">${i}</label>
            </div>`;
      })
      .join('');

    return `<section class="configurator__section__fields__subsection configurator__section__fields__subsection--main-model configurator__section__fields__subsection--${key}">
                ${title != '' ? `<h3>${title}</h3>` : ``}
                ${items}
            </section>`;
  }

  /**
   * Generate a list of distinct properties based on product configuration and pre-determined keys.
   * @returns {Object} Object containing distinct categories
   */
  _getDistinctProperties(oData = {}, key = null) {
    let result = {
      family: [],
      techLevel: [],
      shellType: [],
    };

    oData = Object.keys(oData).length ? oData : this._props.products;

    for (const item of oData) {
      if (!result.family.includes(item.family)) {
        result.family.push(item.family);
      }

      if (!result.techLevel.includes(item.techLevel)) {
        result.techLevel.push(item.techLevel);
      }

      if (!result.shellType.includes(item.shellType)) {
        result.shellType.push(item.shellType);
      }
    }

    return key != null ? result[key] : result;
  }

  /**
   * doPostBackWidthValidation
   * @param {String} eventTargetClientId - Client target id
   * @param {String} eventArgument - Argument to parse
   * @type {Private}
   */
  _doPostBackWithValidation(eventTargetClientId, eventArgument) {
    //  Sys.WebForms.PageRequestManager.getInstance().add_endRequest(clearPostBackWithValidation);
    __doPostBack(eventTargetClientId, eventArgument);
  }

  _addPIMImageToModal() {
    let debugFunction = false;
    if (debugFunction) {
      console.log(
        '%c_addPIMImageToModal',
        'background: #77AB59; color: #fff; padding: 4px 10px;border-left:0px solid white;',
      );
    }
    // This function will copy the Product image src and use it as the Modal image src, either PIM or Sitecore
    // Detect change, wait for the Product image to have a src, take that src and use it as the image src for the Modal image
    /* eslint-disable-next-line */
    let observer = new MutationObserver(function (mutations) {
      if (debugFunction) {
        console.log(
          '%c_addPIMImageToModal muation detected',
          'background: #77AB59; color: #fff; padding: 4px 10px;border-left:20px solid white;',
        );
      }
      if (document.querySelector('.product_image').getAttribute('src')) {
        if (debugFunction) {
          console.log(
            '%c_addPIMImageToModal .product-image src detected',
            'background: #77AB59; color: #fff; padding: 4px 10px;border-left:20px solid white;',
          );
        }
        let modalImage = document.querySelector('.product_modal__image img');
        let productImage = document.querySelector('.product_image').getAttribute('src');
        if (debugFunction) {
          console.log(
            '%cImage URL: ' + productImage,
            'padding: 4px 10px;border-left:20px solid white;',
          );
        }
        modalImage.src = productImage;
        if (debugFunction) {
          console.log(
            '%cColor: ' +
              document
                .querySelector('color-dropdown .form-select__placeholder .form-select__list-label')
                .innerText.trim(),
            'padding: 4px 10px;border-left:20px solid white;',
          );
        }
        observer.disconnect();
      }
    });
    observer.observe(this._refs.el, {
      attributes: false,
      childList: true,
      characterData: false,
      subtree: true,
    });
  }
}

export default ProductSelector;
